import { useEffect, useState } from "react";
import styled from "@emotion/styled/macro";

const StyledSwitchRoot = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 1.06em .8em;
`;

const StyledSwitchLabel = styled.label`
  position: relative;
  display: inline-block;
  width: 50px;
  height: 24px;
`;

const StyledSwitchSlider = styled.span`
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: #ccc;
  transition: .4s;
  border-radius: 34px;

  &::before {
    position: absolute;
    content: "";
    height: 16px;
    width: 16px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    transition: .4s;
    border-radius: 50%;
  }
`;

const StyledSwitchInput = styled.input`
  opacity: 0;
  width: 0;
  height: 0;

  &:checked + ${StyledSwitchSlider} {
    background-color: #000000;
  }

  &:checked + ${StyledSwitchSlider}:before {
    transform: translateX(26px);
  }

  &:focus + ${StyledSwitchSlider} {  
    box-shadow: 0 0 1px #000000;
  }
`;

export const ButtonSwitch = ({ onChange, children }) => {
  const [checked, setChecked] = useState(false);
  useEffect(() => { onChange(checked); }, [checked, onChange]);
  return (
    <StyledSwitchRoot>
      <StyledSwitchLabel>
        <StyledSwitchInput
          type="checkbox"
          checked={checked}
          onChange={(e) => setChecked(e.target.checked)}
        />
        <StyledSwitchSlider />
      </StyledSwitchLabel>
      {children}
    </StyledSwitchRoot>
  )
};